/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Box, Text } from '@atlaskit/primitives';
import { type DatabaseField, DatabaseFieldType } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';

import AttachmentFieldSettings from './AttachmentFieldSettings';

const unreachable = (fieldType: never): never => {
  throw new Error(`Unsupported field settings menu type: ${fieldType}`);
};

const FieldSettingsPlaceholder: FunctionComponent<{
  fieldType: DatabaseFieldType;
}> = ({ fieldType }) => {
  return (
    <Box paddingBlock="space.100">
      <Text>
        {fieldType}
        {
          // temporary placeholder
        } field settings placeholder
      </Text>
    </Box>
  );
};

export const getFieldSettingsOptionsByType = (
  contentId: string,
  field: DatabaseField<DatabaseFieldType>
): React.ReactElement | null => {
  switch (field.type) {
    case DatabaseFieldType.ATTACHMENT:
      return (
        <AttachmentFieldSettings
          contentId={contentId}
          field={field as DatabaseField<DatabaseFieldType.ATTACHMENT>}
        />
      );

    case DatabaseFieldType.BACKLINK:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.DATE:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.ENTRY_DETAILS:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.ENTRY_LINK:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.HYPERLINK:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.JIRA_ISSUE:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.JIRA_ISSUE_DETAILS:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.NUMBER:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.PAGE_DETAILS:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.PAGE_LABELS:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.PAGE_LINK:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.PAGE_STATUS:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.SELECT:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.TEXT:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.USER:
      return <FieldSettingsPlaceholder fieldType={field.type} />;

    case DatabaseFieldType.AI_SUMMARY:
    case DatabaseFieldType.CHECKBOX:
      return null; // Won't be supporting these field types

    default:
      return unreachable(field.type);
  }
};
